import { useEffect, useState } from "react";

const useClickOutside = (ref) => {
  const [clicked, setClicked] = useState(false);
  useEffect(() => {
    const handleClick = e => {
      if (ref && ref.current && !ref.current.contains(e.target)) {
        setClicked(true);
      } else {
        setClicked(false);
      }
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick)
  }, [ref]);

  return clicked;
}

export default useClickOutside;